import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
`;

export const Content = styled.div`
  margin-top: 16px;

  @media(max-width: 600px) {
    margin-top: 0;
  }
`;
